import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IContextMenuAction } from 'src/app/components/ux/context-menu/context-menu-action.interface';
import { ContextMenuComponent } from 'src/app/components/ux/context-menu/context-menu.component';
import { IWindowProcess } from 'src/app/interfaces/os/window-process.interface';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';
import { ContextMenuService } from 'src/app/services/ux/context-menu.service';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-main-tool-bar',
  templateUrl: './main-tool-bar.component.html',
  styleUrls: ['./main-tool-bar.component.scss']
})
export class MainToolBarComponent implements OnInit {
  @ViewChild("toolbarMenu") toolbarMenu: ContextMenuComponent;
  @ViewChild("toolbarIconMenu") toolbarIconMenu: ContextMenuComponent;

  @Output() startClick = new EventEmitter<any>();

  toolbarMenuActions: IContextMenuAction[] = [];
  iconMenuActions: IContextMenuAction[] = [];

  constructor(
    private contextMenuSv: ContextMenuService,
    private windowsMgrSv: WindowsManagerService,
    public theme: ThemeService
  ) {
  }

  ngOnInit() {
    this.toolbarMenuActions.push({
      name: "Show desktop",
      action: () => { this.windowsMgrSv.minimizeAllWindows(); },
      enableIf: () => this.allWindows.some(m => !m.isMinimized())
    });
  }

  get allWindows() {
    return this.windowsMgrSv.windows;
  }

  startMenuClick(): void {
    this.startClick.emit();
  }

  showContextMenu(ev: MouseEvent): void {
    ev.preventDefault();
    ev.stopPropagation();
    this.closeContextMenu();
    this.contextMenuSv.show(this.toolbarMenu, ev.pageX, ev.pageY);
  }

  showStartContextMenu(ev: MouseEvent): void {
    ev.preventDefault();
    ev.stopPropagation();
  }

  showIconContextMenu(ev: MouseEvent, window: IWindowProcess): void {
    ev.preventDefault();
    ev.stopPropagation();

    //  @todo Use a different method instead of dispose

    this.iconMenuActions = [
      { name: "Close", action: () => { this.windowsMgrSv.disposeWindow(window.id); } }
    ];

    this.closeContextMenu();
    this.contextMenuSv.show(this.toolbarIconMenu, ev.pageX, ev.pageY);
  }

  manageClick() {
    this.closeContextMenu();
  }

  resetStatus(): void {
  }

  windowsId(_index: number, item: IWindowProcess): number {
    return item.id;
  }

  private closeContextMenu() {
    this.contextMenuSv.close();
  }
}
